import { Employment } from './employment.interface';
import { mapEmployment } from './employment.mapper';
import { EmploymentService } from './employment.service';

import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import contractExtension, { ContractExtensionState } from '../customers/employees/contract-extensions/contract-extension.store';

const service = new EmploymentService();

export interface EmploymentState {
   contractExtension?: ContractExtensionState;
}

const EmploymentStore: Module<EmploymentState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async createEmployment(context, employment: Employment) {
         const mappedEmployment = mapEmployment(employment);
         return await service.createEmployment(mappedEmployment);
      },
      async batchCreateEmployments(context, employments: Array<Employment>) {
         const mappedEmployments = employments.map(mapEmployment);
         const batch = await service.batchCreateEmployments(mappedEmployments);
         context.commit('batch/ADD_BATCH', batch, { root: true });
         return batch;
      },
   },
   modules: {
      contractExtension,
   },
};

export default EmploymentStore;
